module.exports = __webpack_public_path__ + "static/media/current-location-icon.c5ebfaff.svg";